// DBA Fitment Finder — reads the master data file (uploaded to Shopify Files)
(function(){
  const SECTION_ORDER = ['Front Rotors','Rear Rotors','Front Pads','Rear Pads'];

  const makeSel = document.getElementById('dba-sel-make');
  const modelSel = document.getElementById('dba-sel-model');
  const yearSel = document.getElementById('dba-sel-year');
  const engineSel = document.getElementById('dba-sel-engine');
  const engineNote = document.getElementById('dba-engine-note');
  const resultsEl = document.getElementById('dba-results');
  const summaryEl = document.getElementById('dba-results-summary');
  const sectionsEl = document.getElementById('dba-sections');
  const addAllRow = document.getElementById('dba-addall-row');
  const addAllBtn = document.getElementById('dba-addall-btn');
  const cartBar = document.getElementById('dba-cart-bar');
  const cartCount = document.getElementById('dba-cart-count');
  const cartTotal = document.getElementById('dba-cart-total');
  const checkoutBtn = document.getElementById('dba-checkout-btn');

  if(!makeSel) return; // section not on this page

  let DATA = [];
  let cartItems = 0, cartValue = 0;

  function uniq(arr){ return [...new Set(arr)]; }
  function fillSelect(sel, values, placeholder){
    sel.innerHTML = '<option value="">' + placeholder + '</option>';
    values.forEach(v => { const o = document.createElement('option'); o.value=v; o.textContent=v; sel.appendChild(o); });
  }
  function currentFilter(){
    return { make: makeSel.value, model: modelSel.value, year: yearSel.value, engine: engineSel.value };
  }
  function matches(rec, f, upTo){
    if(f.make && rec.make !== f.make) return false;
    if(upTo < 2) return true;
    if(f.model && rec.model !== f.model) return false;
    if(upTo < 3) return true;
    if(f.year && !(rec.yearFrom <= parseInt(f.year) && (rec.yearTo === null || rec.yearTo >= parseInt(f.year)))) return false;
    if(upTo < 4) return true;
    if(f.engine && rec.engine !== f.engine) return false;
    return true;
  }

  // Strip a trailing DBA finish/tier suffix (E, EL, ER, S, X, XS, XD, SS, SP, XP, RP...)
  // to get the "family" base part number, so different finishes of the same physical
  // rotor/pad (e.g. EnShield vs T2) collapse into one row with a toggle instead of
  // showing as separate rows.
  function familyOf(sku){
    const m = sku.match(/^(DBA?\d+)/);
    return m ? m[1] : sku;
  }

  function refreshCascade(changedField){
    const f = currentFilter();

    const models = uniq(DATA.filter(r => matches(r,f,1)).map(r=>r.model)).sort();
    const keepModel = changedField==='model' ? f.model : (models.includes(f.model) ? f.model : '');
    fillSelect(modelSel, models, '– Select Model –');
    modelSel.value = keepModel;
    modelSel.disabled = !f.make;

    const f2 = currentFilter();
    const years = uniq(DATA.filter(r=>matches(r,f2,2)).flatMap(r=>{
      const arr=[]; const from=r.yearFrom, to=r.yearTo||r.yearFrom;
      if(from) for(let y=from;y<=to;y++) arr.push(y);
      return arr;
    })).sort((a,b)=>b-a);
    const keepYear = changedField==='year' ? f2.year : (years.map(String).includes(f2.year) ? f2.year : '');
    fillSelect(yearSel, years, '– Select Year –');
    yearSel.value = keepYear;
    yearSel.disabled = !f2.model;

    const f3 = currentFilter();
    const engines = uniq(DATA.filter(r=>matches(r,f3,3)).map(r=>r.engine).filter(Boolean)).sort();

    if(engines.length === 1){
      // Only one engine possible for this year — skip asking, auto-select it.
      fillSelect(engineSel, engines, '– Select Engine –');
      engineSel.value = engines[0];
      engineSel.disabled = true;
      if(engineNote){
        engineNote.textContent = 'Only one engine option for this year — auto-selected (' + engines[0] + ').';
        engineNote.style.display = 'block';
      }
    } else {
      const keepEngine = changedField==='engine' ? f3.engine : (engines.includes(f3.engine) ? f3.engine : '');
      fillSelect(engineSel, engines, '– Select Engine –');
      engineSel.value = keepEngine;
      engineSel.disabled = !f3.year;
      if(engineNote) engineNote.style.display = 'none';
    }

    [makeSel,modelSel,yearSel,engineSel].forEach(s=>s.classList.toggle('filled', !!s.value));
    renderResults();
  }

  function renderResults(){
    const f = currentFilter();
    if(!f.make){
      resultsEl.classList.remove('show');
      if(addAllRow) addAllRow.style.display = 'none';
      return;
    }
    if(!f.model){
      resultsEl.classList.add('show');
      summaryEl.textContent = 'Select a model to continue.';
      sectionsEl.innerHTML = '';
      if(addAllRow) addAllRow.style.display = 'none';
      return;
    }
    if(!f.year){
      resultsEl.classList.add('show');
      summaryEl.textContent = 'Select a year — models can span several different chassis generations, each needing a different part.';
      sectionsEl.innerHTML = '';
      if(addAllRow) addAllRow.style.display = 'none';
      return;
    }
    if(!f.engine){
      resultsEl.classList.add('show');
      summaryEl.textContent = 'Select your engine/chassis to see the exact parts for your vehicle.';
      sectionsEl.innerHTML = '';
      if(addAllRow) addAllRow.style.display = 'none';
      return;
    }

    const matched = DATA.filter(r => matches(r, f, 4));
    resultsEl.classList.add('show');
    if(matched.length === 0){
      summaryEl.textContent = 'No DBA parts found for this vehicle.';
      sectionsEl.innerHTML = '';
      if(addAllRow) addAllRow.style.display = 'none';
      return;
    }
    summaryEl.innerHTML = 'Showing parts for <b>' + f.make + ' ' + f.model + ' ' + f.year + '</b>';

    const bySection = {};
    matched.forEach(r => {
      if(!bySection[r.section]) bySection[r.section] = {};
      bySection[r.section][r.sku] = r;
    });

    sectionsEl.innerHTML = '';
    SECTION_ORDER.forEach(sec => {
      if(!bySection[sec]) return;
      const items = Object.values(bySection[sec]).sort((a,b)=>a.price-b.price);

      // group same-fitment items by base part family (finish variants collapse together)
      const families = new Map();
      items.forEach(item => {
        const fam = familyOf(item.sku);
        if(!families.has(fam)) families.set(fam, []);
        families.get(fam).push(item);
      });

      const block = document.createElement('div');
      block.className = 'dba-section';
      block.innerHTML = '<div class="dba-section-title">' + sec + ' <span class="dba-n">' + families.size + '</span></div>';

      [...families.entries()].forEach(([fam, options]) => {
        options.sort((a,b)=>a.price-b.price);
        const isRotor = sec.includes('Rotors');
        const defaultQty = isRotor ? 2 : 1;
        const row = document.createElement('div');

        if(options.length === 1){
          const item = options[0];
          row.className = 'dba-part-row';
          row.dataset.variant = item.variantId;
          row.innerHTML = `
            <div class="dba-name">
              <div class="dba-series">${item.label}</div>
              <div class="dba-sku">${item.sku}</div>
            </div>
            <div class="dba-price">$${item.price.toFixed(2)}</div>
            <div class="dba-qty">
              <button class="dba-qty-minus" type="button">–</button>
              <input class="dba-qty-input" type="text" inputmode="numeric" value="${defaultQty}">
              <button class="dba-qty-plus" type="button">+</button>
            </div>
            <button class="dba-add-btn" type="button">Add</button>
          `;
        } else {
          row.className = 'dba-part-row dba-part-row-group';
          row.dataset.options = JSON.stringify(options.map(o=>({v:o.variantId,p:o.price}))).replace(/'/g,'&#39;');
          row.dataset.selected = '0';
          const pills = options.map((o,i) => `<button type="button" class="dba-finish-pill${i===0?' active':''}" data-idx="${i}">${o.label.replace(/^Street Series - ?/,'').replace(/^4000 Series - ?/,'').replace(/^5000 Series - ?/,'')}</button>`).join('');
          row.innerHTML = `
            <div class="dba-name">
              <div class="dba-series">${fam}</div>
              <div class="dba-finish-pills">${pills}</div>
            </div>
            <div class="dba-price">$${options[0].price.toFixed(2)}</div>
            <div class="dba-qty">
              <button class="dba-qty-minus" type="button">–</button>
              <input class="dba-qty-input" type="text" inputmode="numeric" value="${defaultQty}">
              <button class="dba-qty-plus" type="button">+</button>
            </div>
            <button class="dba-add-btn" type="button">Add</button>
          `;
        }

        const qtyInput = row.querySelector('.dba-qty-input');
        row.querySelector('.dba-qty-minus').addEventListener('click', () => {
          qtyInput.value = Math.max(1, parseInt(qtyInput.value||'1') - 1);
        });
        row.querySelector('.dba-qty-plus').addEventListener('click', () => {
          qtyInput.value = parseInt(qtyInput.value||'1') + 1;
        });

        if(options.length > 1){
          const priceEl = row.querySelector('.dba-price');
          row.querySelectorAll('.dba-finish-pill').forEach(pill => {
            pill.addEventListener('click', () => {
              row.querySelectorAll('.dba-finish-pill').forEach(p=>p.classList.remove('active'));
              pill.classList.add('active');
              const idx = parseInt(pill.dataset.idx,10);
              row.dataset.selected = idx;
              priceEl.textContent = '$' + options[idx].price.toFixed(2);
            });
          });
          row.querySelector('.dba-add-btn').addEventListener('click', () => {
            const idx = parseInt(row.dataset.selected,10);
            const qty = Math.max(1, parseInt(qtyInput.value||'1'));
            addToCart({ variantId: options[idx].variantId, price: options[idx].price }, qty, row);
          });
        } else {
          row.querySelector('.dba-add-btn').addEventListener('click', () => {
            const qty = Math.max(1, parseInt(qtyInput.value||'1'));
            addToCart(options[0], qty, row);
          });
        }

        block.appendChild(row);
      });
      sectionsEl.appendChild(block);
    });

    if(addAllRow) addAllRow.style.display = 'block';
  }

  function addToCart(item, qty, row){
    const btn = row.querySelector('.dba-add-btn');
    btn.textContent = 'Adding…';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: item.variantId, quantity: qty }] })
    })
      .then(res => {
        if(!res.ok) throw new Error('Cart add failed');
        return res.json();
      })
      .then(() => {
        row.classList.add('dba-added');
        btn.textContent = 'Added ✓';
        btn.disabled = false;
        cartItems += qty;
        cartValue += item.price * qty;
        updateCartBar();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(() => {
        btn.textContent = 'Error — try again';
        btn.disabled = false;
      });
  }

  function wireAddAll(){
    if(!addAllBtn) return;
    addAllBtn.addEventListener('click', () => {
      const rows = [...sectionsEl.querySelectorAll('.dba-part-row')];
      if(!rows.length) return;
      addAllBtn.disabled = true;
      addAllBtn.textContent = 'Adding all parts…';

      const items = rows.map(row => {
        const qty = Math.max(1, parseInt(row.querySelector('.dba-qty-input').value || '1', 10));
        if(row.classList.contains('dba-part-row-group')){
          const options = JSON.parse(row.dataset.options.replace(/&#39;/g,"'"));
          const idx = parseInt(row.dataset.selected, 10) || 0;
          return { id: options[idx].v, quantity: qty, price: options[idx].p, row };
        }
        return { id: parseInt(row.dataset.variant, 10), quantity: qty, price: parseFloat(row.querySelector('.dba-price').textContent.replace('$','')), row };
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items.map(i => ({ id: i.id, quantity: i.quantity })) })
      })
        .then(res => { if(!res.ok) throw new Error('Cart add failed'); return res.json(); })
        .then(() => {
          items.forEach(i => {
            i.row.classList.add('dba-added');
            const addBtn = i.row.querySelector('.dba-add-btn');
            if(addBtn) addBtn.textContent = 'Added ✓';
            cartItems += i.quantity;
            cartValue += i.price * i.quantity;
          });
          updateCartBar();
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          addAllBtn.textContent = 'Taking you to checkout…';
          // Fewest-click path: go straight to Shopify checkout rather than
          // making the customer view the cart and click checkout separately.
          window.location.href = '/checkout';
        })
        .catch(() => {
          addAllBtn.disabled = false;
          addAllBtn.textContent = 'Error adding items — try again';
        });
    });
  }

  function updateCartBar(){
    if(cartItems === 0){ cartBar.classList.remove('show'); return; }
    cartBar.classList.add('show');
    cartCount.textContent = cartItems;
    cartTotal.textContent = cartValue.toFixed(2);
  }

  checkoutBtn.addEventListener('click', () => { window.location.href = '/cart'; });
  wireAddAll();

  // --- Remember last vehicle picked (so a returning visitor skips re-selecting) ---
  function saveVehicle(f){
    try{
      localStorage.setItem('dba_last_vehicle', JSON.stringify({make:f.make, model:f.model, year:f.year, engine:f.engine}));
    }catch(e){ /* private browsing / storage blocked — ignore */ }
  }
  function loadSavedVehicle(){
    try{ return JSON.parse(localStorage.getItem('dba_last_vehicle') || 'null'); }
    catch(e){ return null; }
  }

  // --- Deep-link support: ?make=Subaru&model=Impreza&year=2005&engine=... ---
  // Lets a Meta ad aimed at a specific model land the customer with the
  // vehicle already selected instead of making them pick Make/Model again.
  function paramsFromUrl(){
    const p = new URLSearchParams(window.location.search);
    const make = p.get('make'), model = p.get('model'), year = p.get('year'), engine = p.get('engine');
    if(!make) return null;
    return { make, model: model||'', year: year||'', engine: engine||'' };
  }

  function applyPreset(preset){
    if(!preset || !preset.make) return;
    makeSel.value = preset.make;
    if(makeSel.value !== preset.make) return; // make not found in data, bail quietly
    refreshCascade('make');
    if(preset.model){
      modelSel.value = preset.model;
      if(modelSel.value === preset.model) refreshCascade('model');
    }
    if(preset.year){
      yearSel.value = preset.year;
      if(yearSel.value === preset.year) refreshCascade('year');
    }
    if(preset.engine && !engineSel.disabled){
      engineSel.value = preset.engine;
      if(engineSel.value === preset.engine) refreshCascade('engine');
    }
  }

  [makeSel,modelSel,yearSel,engineSel].forEach(sel => {
    sel.addEventListener('change', () => saveVehicle(currentFilter()));
  });

  makeSel.addEventListener('change', () => refreshCascade('make'));
  modelSel.addEventListener('change', () => refreshCascade('model'));
  yearSel.addEventListener('change', () => refreshCascade('year'));
  engineSel.addEventListener('change', () => refreshCascade('engine'));

  // Fetch the master data file and initialize once it's loaded
  fetch(window.DBA_FINDER_DATA_URL)
    .then(res => res.json())
    .then(data => {
      DATA = data;
      fillSelect(makeSel, uniq(DATA.map(r=>r.make)).sort(), '– Select Make –');
      makeSel.disabled = false;

      // Ad deep-link takes priority; otherwise offer to restore last vehicle.
      const urlPreset = paramsFromUrl();
      if(urlPreset){
        applyPreset(urlPreset);
      } else {
        const saved = loadSavedVehicle();
        if(saved && saved.make){
          const banner = document.createElement('div');
          banner.className = 'dba-engine-note';
          banner.style.display = 'block';
          banner.innerHTML = 'Looking for parts for your <b>' + saved.make + ' ' + saved.model + '</b> again? '
            + '<button type="button" id="dba-restore-vehicle" style="margin-left:.4rem;text-decoration:underline;background:none;border:none;color:inherit;cursor:pointer;font:inherit;">Yes, use it</button>';
          makeSel.closest('.dba-finder-form').appendChild(banner);
          document.getElementById('dba-restore-vehicle').addEventListener('click', () => {
            banner.remove();
            applyPreset(saved);
          });
        }
      }
    })
    .catch(() => {
      makeSel.innerHTML = '<option value="">Unable to load fitment data</option>';
    });
})();